module.exports = __webpack_public_path__ + "static/about-joyner-fmd-c76223f067eecc5720fc87a4f738c49e.jpg";